<template>
  <div class="rootDiv">
    <div v-for="item in ItemList" :key="item.sXMC" style="margin-left: -0.5rem;margin-right: -0.5rem">
      <div class="title-div" style="position: relative">
        <span style="margin-top: 1rem">{{ item.sXMC === null ? '未知城市' : item.sXMC }}</span>
        <span>{{ '（' + item.airportList.length + '个）' }}</span>
        <img v-if="item.sXMC===null" src="../../../assets/images/16/warning.png" width="16" height="16" alt="">
        <img src="../../../assets/images/32/map.png" alt="" width="24" height="24" @click="GoMap(item.airportList)"
             style="position: absolute;top: 50%;bottom: 50%;margin: auto">
      </div>
      <Cell :title="airport.iATA===null?airport.jCMC:(airport.jCMC+'（'+airport.iATA+'）')"
            v-for="airport in item.airportList"
            :key="airport.iD" class="cellstyle"
            v-on:click.native="Go(airport,airport.iATA)"
            :is-link="airport.iATA!==null">
        <img v-if="airport.iATA===null" src="../../../assets/images/16/warning.png" width="16" height="16" alt=""
             style="margin-right: 20px">
        <span style="color: #2986de">{{ airport.dJ }}</span>
      </Cell>
    </div>
  </div>
</template>

<script>
import {Indicator, Cell} from "mint-ui";

export default {
  name: "AirportList",
  components: {
    Cell
  },
  mounted() {
    if (this.$route.query.sXMC !== undefined) {
      switch (this.$route.query.type) {
        case 'province': {
          this.getAirportList(this.$route.query.sXMC, this.getAirportListByProvinceUrl)
          break
        }
        case 'level': {
          this.getAirportList(this.$route.query.sXMC, this.getAirportListByLevelUrl)
          break
        }
        case 'region': {
          this.getAirportList(this.$route.query.sXMC, this.getAirportListByRegionUrl)
          break
        }
      }
    } else
      this.$router.go(-1)
  },
  data() {
    return {
      ItemList: [],
      token: localStorage.getItem('token'),
      getAirportListByProvinceUrl: '/api/airport/getAirportListByProvince',
      getAirportListByLevelUrl: '/api/airport/getAirportListByLevel',
      getAirportListByRegionUrl: '/api/airport/getAirportListByRegion',
    }
  },
  methods: {
    GoMap(airportList) {
      let list = []
      airportList.forEach(x => {
        let item = {title: x.jCMC, data: {jD: x.jD, wD: x.wD, dJ: x.dJ}}
        list.push(item)
      })
      this.$router.push({name: 'm_bing_map', query: {point: list}})
    },
    getAirportList(sXMC, url) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: url,
        params: {SXMC: sXMC},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ItemList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    Go(item, bo) {
      if (bo)
        this.$router.push({path: 'm_airport_details', query: {key_id: item.iD}})
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
}
</style>
